module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('sidebar-item', {
    attrs: {
      "routes": _vm.siderbar_routers.children
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39ec96fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 103
// module chunks = 83